import { createRoot } from "react-dom/client";
import { fetch } from '@/lib/api';
import { ThemeProvider } from "@/components/ui/theme-provider";
import App from "./App";
import "./index.css";
import { registerSW } from 'virtual:pwa-register';
import { PushNotifications } from '@capacitor/push-notifications';
import { Capacitor } from '@capacitor/core';
import { App as CapApp } from '@capacitor/app';

// DISABLE service worker registration in Capacitor
if ('serviceWorker' in navigator && !window.Capacitor) {
  navigator.serviceWorker.register('/sw.js')
}

createRoot(document.getElementById("root")!).render(
  <ThemeProvider defaultTheme="light" storageKey="alento-theme">
    <App />
  </ThemeProvider>
);

if (Capacitor.isNativePlatform()) {
  CapApp.addListener('backButton', ({ canGoBack }) => {
    if (!canGoBack) {
      CapApp.exitApp();
    } else {
      window.history.back();
    }
  });
}

// Initialize Sentry if available globally (optional) and DSN provided
if ((window as any).__SENTRY_DSN__ && (window as any).Sentry?.init) {
  (window as any).Sentry.init({ dsn: (window as any).__SENTRY_DSN__ });
}

// Register PWA service worker (auto update) after the app is idle
const defer = (fn: () => void) => {
  if ((window as any).requestIdleCallback) {
    (window as any).requestIdleCallback(fn);
  } else {
    setTimeout(fn, 1500);
  }
};

defer(() => registerSW({ immediate: true }));

// Register for push notifications and send token to server (best-effort)
async function registerPush() {
  try {
    const permStatus = await PushNotifications.checkPermissions();
    if (permStatus.receive !== 'granted') {
      const req = await PushNotifications.requestPermissions();
      if (req.receive !== 'granted') return;
    }
    await PushNotifications.register();
    PushNotifications.addListener('registration', async (token) => {
      try {
        const platform = /iPhone|iPad|iPod/i.test(navigator.userAgent) ? 'ios' : (/Android/i.test(navigator.userAgent) ? 'android' : 'web');
        await fetch('/api/push/register', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          credentials: 'include',
          body: JSON.stringify({ platform, token: token.value })
        });
      } catch {}
    });
    PushNotifications.addListener('registrationError', (_e) => {});
  } catch {}
}

// Defer push registration to avoid impacting initial interactivity
defer(registerPush);
